import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import CreateNewCouponForm from '../../../../Componant/Application/Project/master/CreateNewCouponForm'


const CouponCreateContainer = () => {
  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <CreateNewCouponForm />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default CouponCreateContainer